import { render, staticRenderFns } from "./BookingPrescriber.vue?vue&type=template&id=322da877&"
import script from "./BookingPrescriber.vue?vue&type=script&lang=ts&"
export * from "./BookingPrescriber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports